import { GraphStyle } from 'components/planner/types'
import { getRelativePointerPosition } from 'components/planner/utils/tools'
import { KonvaEventObject } from 'konva/lib/Node'
import React, { useEffect, useRef } from 'react'
import { Group, Rect } from 'react-konva'


function ScrollVert({
	x,
	y,
	height,
	width,
	heightTot,
	scrollYByWeel,
	style,

	onChange,
}: ScrollVertProps) {

	const bgRef = useRef(null)
	const cursorRef = useRef(null)
	const timeoutIdRef = useRef(0)

	const factor = height / heightTot
	const cursorHeight = height * factor

	useEffect(() => {
		if (!cursorRef.current) return
		let scroll = (scrollYByWeel) * factor
		if (scroll < 0) scroll = 0
		if (scroll + cursorHeight > height) scroll = height - cursorHeight
		cursorRef.current.y(scroll)
		onChange?.(scroll / factor)
	}, [scrollYByWeel])

	useEffect(() => {
		if (heightTot < height) {
			onChange?.(0)
			return
		}
		if (!cursorRef.current) return
		const y = cursorRef.current.y()
		onChange?.(y / factor)
	}, [heightTot])

	/**Utilizzato per delimitare i limiti del drag */
	const callbackDrag = pos => {
		const posRel = bgRef.current.absolutePosition()
		pos.x = posRel.x
		if (pos.y < posRel.y) pos.y = posRel.y
		if (pos.y + cursorHeight > (posRel.y + height)) pos.y = posRel.y + height - cursorHeight
		return pos
	}

	const handleDragMove = (e: KonvaEventObject<MouseEvent>) => {
		e.cancelBubble = true
		const y = e.target.y()
		//const days = calcDaysFromX(x)
		if (timeoutIdRef.current != 0) return
		timeoutIdRef.current = window.setTimeout(() => {
			onChange?.(y / factor)
			timeoutIdRef.current = 0
		}, 25)
	}

	const handleClick = e => {
		e.cancelBubble = true
		const pos = getRelativePointerPosition(e.target)
		const y = pos.y - (cursorHeight / 2)
		onChange?.(y / factor)
		cursorRef.current.y(y)
	}

	if (factor > 0.999 || factor < 0) return null

	return (<Group x={x} y={y} width={width} height={height}>
		<Rect ref={bgRef}
			onClick={handleClick}
			onTap={handleClick}
			fill={style.scroll.bg.color}
			x={0} y={0}
			width={width} height={height}
		/>
		<Rect ref={cursorRef}
			onDragMove={handleDragMove}
			draggable
			dragBoundFunc={callbackDrag}
			fill={style.scroll.cursor.color}
			x={0/*value*/} y={0}
			height={cursorHeight} width={width}
		/>
	</Group>)
}

export default ScrollVert

type ScrollVertProps = {
	x: number,
	y: number,
	height: number,
	width: number,
	/** altezza totale oltre la finestra scrollata */
	heightTot: number,
	/** posizione scroll  */
	scrollYByWeel: number,
	style: GraphStyle,

	/** chiamato quando si scrolla */
	onChange: (posY: number) => void,
}